import { jsx as _jsx } from "react/jsx-runtime";
import { IconCircle, IconCircleFilled } from "@tabler/icons-react";
export const UsedSourceLayerIcon = ({ isUsed }) => {
    return isUsed
        ? _jsx(IconCircleFilled, { size: 16, stroke: 1.5 })
        : _jsx(IconCircle, { size: 16, stroke: 1.5 });
};
